import { Joint, UnifiedHandJoints } from '@exerai/vision-engine-web';

export const initKeypoints: { [key in UnifiedHandJoints]: Joint } = {
    [UnifiedHandJoints.WRIST]: {
        dsId: 'WRIST',
        name: 'Wrist',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.THUMB_CMC]: {
        dsId: 'THUMB_CMC',
        name: 'Thumb Carpometacarpal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.THUMB_MP]: {
        dsId: 'THUMB_MP',
        name: 'Thumb Metacarpophalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.THUMB_IP]: {
        dsId: 'THUMB_IP',
        name: 'Thumb Interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.THUMB_TIP]: {
        dsId: 'THUMB_TIP',
        name: 'Thumb Tip',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.INDEX_MCP]: {
        dsId: 'INDEX_MCP',
        name: 'Index Metacarpophalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.INDEX_PIP]: {
        dsId: 'INDEX_PIP',
        name: 'Index Proximal Interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.INDEX_DIP]: {
        dsId: 'INDEX_DIP',
        name: 'Index Distal interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.INDEX_TIP]: {
        dsId: 'INDEX_TIP',
        name: 'Index Tip',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.MIDDLE_MCP]: {
        dsId: 'MIDDLE_MCP',
        name: 'Middle Metacarpophalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.MIDDLE_PIP]: {
        dsId: 'MIDDLE_PIP',
        name: 'Middle Proximal Interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.MIDDLE_DIP]: {
        dsId: 'MIDDLE_DIP',
        name: 'Middle Distal interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.MIDDLE_TIP]: {
        dsId: 'MIDDLE_TIP',
        name: 'Middle Tip',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.RING_MCP]: {
        dsId: 'RING_MCP',
        name: 'Ring Metacarpophalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.RING_PIP]: {
        dsId: 'RING_PIP',
        name: 'Ring Proximal Interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.RING_DIP]: {
        dsId: 'RING_DIP',
        name: 'Ring Distal interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.RING_TIP]: {
        dsId: 'RING_TIP',
        name: 'Ring Tip',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.LITTLE_MCP]: {
        dsId: 'LITTLE_MCP',
        name: 'Little Metacarpophalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.LITTLE_PIP]: {
        dsId: 'LITTLE_PIP',
        name: 'Little Proximal Interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.LITTLE_DIP]: {
        dsId: 'LITTLE_DIP',
        name: 'Little Distal interphalangeal',
        hexColor: '#2dc1bb',
        hidden: false,
    },
    [UnifiedHandJoints.LITTLE_TIP]: {
        dsId: 'LITTLE_TIP',
        name: 'Little Tip',
        hexColor: '#2dc1bb',
        hidden: false,
    },
};
